export const glossaire_type_de_vue = {
  plan_et_carte: 0,
  tableau_de_bord: 1,
  planning_base_vie: 6,
  planning_electrovanne: 5,
};
